import React from 'react'

/**
 * Dentro deste contexto (true), os seletores de unidade seguem a unidade escolhida no topo mesmo onde pedem para
 * ignora-la ({@code ignorarUnidadeDoTopo}). Usado pelo filtro salvo de relatorio (PHOENIX-107): com unidade no topo,
 * o filtro de unidade nasce com ela e fica travado, como nos cadastros. O agendamento (PHOENIX-106) continua
 * ignorando o topo.
 */
export const SeguirUnidadeDoTopo = React.createContext(false)
